import { gql } from '@apollo/client';
export const BENEFIT_PERIOD_FIELDS = gql `
  fragment BenefitPeriodFields on BenefitPeriod {
    id
    clientId
    type
    year
    segment
    target
    criteria
    sortOrder
    startDate
    endDate
    createdAt
    updatedAt
  }
`;
export const BENEFIT_PERIODS = gql `
  ${BENEFIT_PERIOD_FIELDS}
  query BENEFIT_PERIODS($spec: BenefitPeriodSpec!) {
    benefitPeriods(spec: $spec) {
      ...BenefitPeriodFields
    }
  }
`;
export const SAVE_BENEFT_PERIOD = gql `
  ${BENEFIT_PERIOD_FIELDS}
  mutation SAVE_BENEFT_PERIOD($input: BenefitPeriodInput!) {
    saveBenefitPeriod(input: $input) {
      ...BenefitPeriodFields
    }
  }
`;
export const DELETE_BENEFT_PERIOD = gql `
  ${BENEFIT_PERIOD_FIELDS}
  mutation DELETE_BENEFT_PERIOD($id: Int!) {
    deleteBenefitPeriod(id: $id) {
      ...BenefitPeriodFields
    }
  }
`;
